import { AdyenCheckout, Dropin, Card, CoreConfiguration } from '@adyen/adyen-web'
import { Component, OnInit, Renderer2 } from '@angular/core'
import { Router } from '@angular/router'

import Country from 'src/app/core/models/country'

import environment from '../../../environments/environment'
import BookingService from '../../core/booking.service'
import LocalStorageService from '../../core/local-storage.service'
import PspProvider from '../../core/models/psp-provider'
import TranslateService from '../../core/translate.service'
import ModalService from '../../shared/modal/modal.service'
import ScriptService from '../../shared/script.service'
import CreditCardRegistrationService from '../credit-card-registration.services'

declare let payex: any

@Component({
  selector: 'app-credit-card-needed',
  templateUrl: './credit-card-needed.component.html',
  styleUrls: ['./credit-card-needed.component.scss'],
})
export default class CreditCardNeededComponent implements OnInit {
  dropin: Dropin | undefined

  loading = true
  renderPaymentError = false
  rentalPhoneNumber = ''
  rentalPhoneNumberLink = ''

  constructor(
    private router: Router,
    private bookingService: BookingService,
    private renderer: Renderer2,
    private scriptService: ScriptService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
    private modalService: ModalService,
    private creditCardRegistrationService: CreditCardRegistrationService
  ) {}
  ngOnInit(): void {
    this.setRentalPhoneNumber()

    const paymentState = this.localStorageService.getPaymentState()
    if (paymentState) {
      const scriptElement = this.scriptService.loadJsScript(this.renderer, paymentState.viewPaymentUrl)
      scriptElement.onload = () => {
        this.loadSeamlessView(paymentState.orderRef)
      }
    } else {
      this.bookingService.getViewPaymentUrl().subscribe((viewPaymentInfo) => {
        if (viewPaymentInfo.provider === PspProvider.PAYEX) {
          const scriptElement = this.scriptService.loadJsScript(this.renderer, viewPaymentInfo?.viewPaymentUrl)

          this.localStorageService.setPaymentState(viewPaymentInfo)

          scriptElement.onload = () => {
            this.loadSeamlessView(viewPaymentInfo?.orderRef)
          }
        } else if (viewPaymentInfo.provider === PspProvider.ADYEN) {
          this.loadAdyen(viewPaymentInfo.sessionId, viewPaymentInfo.sessionData, viewPaymentInfo.orderRef, viewPaymentInfo.termsAndConditionsUrl)
        }
      })
    }
  }

  async loadAdyen(id: string, sessionData: string, orderRef: string, termsAndConditionsUrl: string): Promise<void> {
    const locale = this.localStorageService.getLocale() === 'nb-NO' ? 'no-NO' : this.localStorageService.getLocale()
    const session = { id, sessionData }
    const termsOfServiceDiv = document.getElementById("terms-of-service") as HTMLAnchorElement | null
    const termsOfServiceHref = document.getElementById("terms-of-service-link") as HTMLAnchorElement | null
    const globalConfiguration: CoreConfiguration = {
      session,
      environment: environment.adyenEnvironment as CoreConfiguration['environment'],
      amount: { value: 0, currency: 'EUR' },
      locale,
      countryCode: this.countryToIso(this.localStorageService.getCurrentCountry()),
      clientKey: environment.adyenClientKey,
      onPaymentCompleted: () => {
        this.confirmCheckIn(orderRef)
      },
      onPaymentFailed: (result, component) => {
        component?.setStatus('ready')
        this.renderPaymentError = true
      },
      onError: (result, component) => {
        component?.setStatus('ready')
        this.renderPaymentError = true
      },
      onChange: () => {
        this.renderPaymentError = false
      },
    }

    const dropinConfiguration = {
      paymentMethodComponents: [Card],
    }
    AdyenCheckout(globalConfiguration).then((checkout) => {
      this.loading = false
      this.dropin = new Dropin(checkout, dropinConfiguration).mount('#psp-container')
      termsOfServiceDiv.style.display = "block"
      termsOfServiceHref.href = termsAndConditionsUrl
    })
  }

  loadSeamlessView(orderRef: string): void {
    const self = this
    const config = {
      container: 'psp-container',
      onPaymentCompleted: () => {
        self.confirmCheckIn(orderRef)
      },
    }
    this.loading = false
    payex.hostedView.creditCard(config).open()
  }

  /**
   * PUT booking information to backend and navigate to confirmation page on click
   */
  confirmCheckIn(orderRef: string): void {
    this.bookingService.getMaskedCreditCardNumber(orderRef).subscribe({
      next: () => {
        const callback = (valid: boolean) => {
          if (!valid) {
            this.localStorageService.setStepValid('/driver-details')
            this.router.navigate(['/driver-details'], {
              state: { personalIdentityNumberValidationFailed: true },
            })
            return
          }

          this.localStorageService.removePaymentState()
          this.creditCardRegistrationService.setShowCreditCardNeeded(false)
          this.localStorageService.setStepValid('/confirmation')
          this.router.navigate(['/confirmation'])
        }

        this.localStorageService.saveOrderRef(orderRef)
        this.bookingService.putBooking(callback.bind(this))
      },
    })
  }

  countryToIso(country: Country): string {
    switch (country) {
      case Country.Finland:
        return 'FI'
      case Country.Norway:
        return 'NO'
      case Country.Sweden:
        return 'SE'
      default:
        return 'SE'
    }
  }

  openModal(id: string): void {
    this.modalService.open(id)
  }

  private setRentalPhoneNumber(): void {
    const booking = this.localStorageService.getBooking()
    const stationNumber = booking?.pickupPlace?.phoneNumber || booking?.pickupStation?.phoneNumber
    const fallbackNumber = this.translate.getTranslation('footer-customer-support-phone-number')

    this.rentalPhoneNumber = stationNumber || fallbackNumber || ''
    this.rentalPhoneNumberLink = this.rentalPhoneNumber.replace(/\s/g, '')
  }
}
